/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Preset_24hInputs */

const en_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last 24 hours`)
};

const zh_hans1_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最近 24 小时`)
};

const pt_br2_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 24 horas`)
};

const es_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Últimas 24 horas`)
};

const fr_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`24 dernières heures`)
};

const de_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzte 24 Stunden`)
};

const ru_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последние 24 часа`)
};

const it_usage_preset_24h = /** @type {(inputs: Usage_Preset_24hInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultime 24 ore`)
};

/**
* | output |
* | --- |
* | "Last 24 hours" |
*
* @param {Usage_Preset_24hInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_preset_24h = /** @type {((inputs?: Usage_Preset_24hInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Preset_24hInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_preset_24h(inputs)
	if (locale === "pt-BR") return pt_br2_usage_preset_24h(inputs)
	if (locale === "es") return es_usage_preset_24h(inputs)
	if (locale === "fr") return fr_usage_preset_24h(inputs)
	if (locale === "de") return de_usage_preset_24h(inputs)
	if (locale === "ru") return ru_usage_preset_24h(inputs)
	if (locale === "it") return it_usage_preset_24h(inputs)
	return en_usage_preset_24h(inputs)
});